import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { DEFAULT_EVAL_MODEL_ID } from '../constants';
import type { CreateEvalConfigFormState } from '../types';
import { createEvalConfigFormSchema } from '../validation/schema';

export function useCreateEvalConfigForm() {
  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
    watch,
    reset,
  } = useForm<CreateEvalConfigFormState>({
    defaultValues: {
      name: '',
      description: '',
      workflow_type: 'LENS_BY_LENS',
      model_id: DEFAULT_EVAL_MODEL_ID,
      copy_from: 'BLANK',
    },
    resolver: zodResolver(createEvalConfigFormSchema),
    mode: 'onTouched',
  });

  return {
    control,
    handleSubmit,
    isValid,
    isSubmitting,
    reset,
    formValues: watch(),
  };
}
